<template>
  <div style="position: relative; width:960px">
    <el-breadcrumb separator=""
                   style="margin-top: 12px">
      <el-breadcrumb-item>开发支持</el-breadcrumb-item>
      <el-breadcrumb-item><img src="../assets/icon-bread-arrow.svg"
             alt=""></el-breadcrumb-item>
      <el-breadcrumb-item>行政区域查询</el-breadcrumb-item>
    </el-breadcrumb>
    <anchor class="title-wrap"
            style="width:150px">
      <anchor-link href="#id-product-introduction"
                   title="产品介绍" />
      <anchor-link href="#id-application-scene"
                   title="适用场景" />
      <anchor-link href="#id-instructions-for-use"
                   title="使用说明" />
      <anchor-link href="#division-search"
                   title="行政区域查询" />
      <anchor-link href="#division-search"
                   title="行政区域查询" />
    </anchor>
    <div id="content-containter"
         style="width: 788px;">
      <h1>行政区域查询</h1>
      <span class="time">最后更新时间：2022年01月10日</span>
      <h2 id="id-product-introduction">产品介绍</h2>
      <ul>
        <li>
          <p>
            行政区域查询API是通过HTTP协议访问远程服务的接口，根据用户输入的搜索条件帮助用户快速查找特定的行政区域信息。 </p>
        </li>
      </ul>
      <h2 id="id-application-scene">适用场景</h2>
      <p>
      <ul>
        <li>
          <p>
            用户希望通过得到行政区域信息，进行开发工作。
          </p>
        </li>
      </ul>
      </p>
      <h2 id="id-instructions-for-use">使用说明</h2>
      <p>
      <ul>
        <li>第一步，申请Web服务API类型Key；</li>
        <li>第二步，参考接口文档发起HTTP/HTTPS请求；</li>
        <li>第三步，接收请求返回的JSON数据。</li>
      </ul>
      </p>
      <div id="division-container">
        <h2 id="division-search">行政区域查询</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>行政区域查询API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/search/division?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>GET</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-请求参数">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>keywords</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>查询关键字</p>
                </td>
                <td>
                  <p>支持行政区划编码或名称。如：<font data-size="14"
                          style="font-size:14px;line-height:22px">370000或山东省<br>直辖市名称默认返回省级别，若需返回市级别请使用行政编码。</font>
                  </p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>subdistrict</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>子级行政区</p>
                </td>
                <td>
                  <p>返回的下属区划层级数，最大值为3。如：1，2，3。（选填，默认为0）</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>0</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>show_fields</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果控制</p>
                </td>
                <td>
                  <p>
                    <font data-size="14"
                          style="font-size:14px;line-height:22px">show_fields用来筛选response结果中的可选字段。<br>show_fields使用规则如下：<br>1、可指定返回字段<br>
                      <ul style="list-style-type:disc;list-style-position:inside;">
                        <li>polyline(只有是树状结构时，最外层对象才会展示)</li>
                      </ul><br>2、多个字段间采用“|”进行分割；<br>3、show_fields未设置时，只返回基础信息
                    </font>
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="3">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>数据类型</strong></p>
                </th>
                <th>
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="3">
                  <p><span>status</span></p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p><span>状态</span></p>
                </td>
                <td>
                  <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p><span>msg</span></p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p><span>状态描述</span></p>
                </td>
                <td>
                  <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p><span>districts</span></p>
                </td>
                <td>
                  <p v-text="'array<district>'"></p>
                </td>
                <td>
                  <p><span>行政区列表</span></p>
                </td>
                <td>
                  <p><span>&nbsp;</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="7">
                  <p></p>
                </td>
                <td colspan="2">
                  <p><span>district</span></p>
                </td>
                <td>
                  <p>entity</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="6">
                  <p></p>
                </td>
                <td>
                  <p><span>adcode</span></p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p><span>区域编码</span></p>
                </td>
                <td>
                  <p><span>街道没有独有的adcode，均继承父类（区县）的adcode</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>name</span></p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p><span>行政区名称</span></p>
                </td>
                <td>
                  <p><span>&nbsp;</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>polyline</span></p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p><span>行政区边界坐标点</span></p>
                </td>
                <td>
                  <p><span>&nbsp;</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>level</span></p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p><span>行政区划级别</span></p>
                </td>
                <td>
                  <p><span>2、country：国家</span></p>
                  <p><span>4、province：省份（直辖市会在province和city显示）</span></p>
                  <p><span>5、city：市（直辖市会在province和city显示）</span></p>
                  <p><span>6、district：区县</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>location</span></p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p><span>位置</span></p>
                </td>
                <td>
                  <p><span>lng,lat</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>children</span></p>
                </td>
                <td>
                  <p v-text="'array<district>'"></p>
                </td>
                <td>
                  <p><span>下级行政区列表，包含district元素</span></p>
                </td>
                <td>
                  <p><span>&nbsp;</span></p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-服务示例">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <div class="service-example">
          <p style="text-align:left;word-break:break-all">
            https://lbsapi.meituan.com/v1/search/division?key=&lt;用户的key&gt;&keywords=山东省&subdistrict=2&show_fields= </p>
        </div>
        <division />
      </div>
    </div>
  </div>
</template>
<script>
import '@ss/mtd-vue/lib/theme2/anchor.css'
import '@ss/mtd-vue/lib/theme2/anchor-link.css'
import Anchor from '@/views/support/anchor/anchor.vue'
import AnchorLink from '@/views/support/anchor/anchor-link.vue'
import Division from './Division.vue'
export default {
  components: {
    Anchor,
    AnchorLink,
    Division
  }
}
</script>
<style lang="less" scoped>
@import '../document.less';

.title-wrap {
  // right: calc(50vw - 590px);
  // float: right;
  position: absolute;
  right: 0px;
  top: 100px;
  .mtd-anchor .mtd-anchor-link {
    font-size: 14px !important;
  }
}

/deep/.mtd-anchor-link-active .mtd-anchor-link-title {
  color: #a46e00 !important;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
/deep/.title-wrap .mtd-anchor-ink-ball {
  background-color: #ffd100 !important;
}
/deep/ .mtd-anchor-link-title:hover {
  color: #a46e00;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
</style>
